import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme/theme';
import './index.css';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Layout from './components/Layout';
import MfaEnrollment from './modules/MFA/MfaEnrollment';
import MfaVerification from './modules/MFA/MfaVerification';


function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <Switch>
              {/* Public routes */}
              <Route path="/login" component={Login} />
              <Route path="/mfa/enroll" component={MfaEnrollment} />
              <Route path="/mfa/verify" component={MfaVerification} />

              {/* Protected routes with Layout */}
              <ProtectedRoute path="/" component={Layout} />
            </Switch>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;